import type { SVGProps } from 'react';
const SvgPedestalSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" {...props}>
    <path d="M96 0C60.7 0 32 28.7 32 64v352h384V64c0-35.3-28.7-64-64-64zm24 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48m184 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32z" />
  </svg>
);
export default SvgPedestalSolid;
